export default __webpack_public_path__ + "static/media/green asset wallet.ce716082.svg";